// extracted by mini-css-extract-plugin
export default {"buttonContainer":"S5yya","alignToEdge":"_84cOt","buttonIcon":"_8ogUt","buttonCaption":"lrThq","buttonSpacer":"s-c6x"};